module.exports = __webpack_public_path__ + "media/images/weather/81_day_g-56ef375b508033bc505b70ba3b1914b7.png";